 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","aboutus-aboutus-module":"aboutus-aboutus-module","accountmanagement-accountmanagement-module":"accountmanagement-accountmanagement-module","app-update-app-update-module":"app-update-app-update-module","addfunds-addfunds-module":"addfunds-addfunds-module","applypromocode-applypromocode-module":"applypromocode-applypromocode-module","congratulationspage-congratulationspage-module":"congratulationspage-congratulationspage-module","contest-listing-contest-detail-contest-detail-module":"contest-listing-contest-detail-contest-detail-module","createcontestpage-createcontestpage-module":"createcontestpage-createcontestpage-module","createteams-createteams-module":"createteams-createteams-module","otppage-otppage-module":"otppage-otppage-module","referralpage-referralpage-module":"referralpage-referralpage-module","usernamepage-usernamepage-module":"usernamepage-usernamepage-module","contactus-contactus-module":"contactus-contactus-module","contest-listing-contest-listing-module":"contest-listing-contest-listing-module","default~games-games-module~games-pickem-lobbypage-pickem-lobbypage-module~more-more-module~mycontest~108e04ff":"default~games-games-module~games-pickem-lobbypage-pickem-lobbypage-module~more-more-module~mycontest~108e04ff","default~games-pickem-lobbypage-pickem-lobbypage-module~pickem-lobbypage-pickem-lobbypage-module":"default~games-pickem-lobbypage-pickem-lobbypage-module~pickem-lobbypage-pickem-lobbypage-module","default~games-games-module~lobbypage-lobbypage-module~more-more-module~mycontest-mycontest-module~my~433ebe54":"default~games-games-module~lobbypage-lobbypage-module~more-more-module~mycontest-mycontest-module~my~433ebe54","lobbypage-lobbypage-module":"lobbypage-lobbypage-module","games-games-module":"games-games-module","default~more-more-module~pick-mobile-pick-mobile-module":"default~more-more-module~pick-mobile-pick-mobile-module","pick-mobile-pick-mobile-module":"pick-mobile-pick-mobile-module","default~mycontest-mycontest-module~mycontest-pickem-mycontest-pickem-module":"default~mycontest-mycontest-module~mycontest-pickem-mycontest-pickem-module","mycontest-pickem-mycontest-pickem-module":"mycontest-pickem-mycontest-pickem-module","profile-profile-module":"profile-profile-module","default~referfriendmodel-referfriendmodel-module~referpage-referpage-module~share-contest-share-cont~f0a6b986":"default~referfriendmodel-referfriendmodel-module~referpage-referpage-module~share-contest-share-cont~f0a6b986","default~referfriendmodel-referfriendmodel-module~referpage-referpage-module":"default~referfriendmodel-referfriendmodel-module~referpage-referpage-module","referfriendmodel-referfriendmodel-module":"referfriendmodel-referfriendmodel-module","referpage-referpage-module":"referpage-referpage-module","signuppage-signuppage-module":"signuppage-signuppage-module","emailpage-emailpage-module":"emailpage-emailpage-module","faq-faq-module":"faq-faq-module","how-to-play-how-to-play-module":"how-to-play-how-to-play-module","joincontest-joincontest-module":"joincontest-joincontest-module","legality-legality-module":"legality-legality-module","mywallet-mywallet-module":"mywallet-mywallet-module","notifications-notifications-module":"notifications-notifications-module","offerpage-offerpage-module":"offerpage-offerpage-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","privacy-policy-privacy-policy-module":"privacy-policy-privacy-policy-module","rulespage-rulespage-module":"rulespage-rulespage-module","shadow-css-360bb6da-js":"shadow-css-360bb6da-js","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","splashdefault-splashdefault-module":"splashdefault-splashdefault-module","termsandcondtion-termsandcondtion-module":"termsandcondtion-termsandcondtion-module","transaction-history-transaction-history-module":"transaction-history-transaction-history-module","whatsnewpage-whatsnewpage-module":"whatsnewpage-whatsnewpage-module","withdrawalmoney-withdrawalmoney-module":"withdrawalmoney-withdrawalmoney-module","withdrawalpending-withdrawalpending-module":"withdrawalpending-withdrawalpending-module","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","deleteaccount-deleteaccount-module":"deleteaccount-deleteaccount-module","fieldview-fieldview-module":"fieldview-fieldview-module","filter-teams-filter-teams-module":"filter-teams-filter-teams-module","gameon-gameon-module":"gameon-gameon-module","myteams-myteams-module":"myteams-myteams-module","player-info-player-info-module":"player-info-player-info-module","player-stats-player-stats-module":"player-stats-player-stats-module","select-captain-select-captain-module":"select-captain-select-captain-module","confirmation-confirmation-module":"confirmation-confirmation-module","contest-filter-contest-filter-module":"contest-filter-contest-filter-module","share-contest-share-contest-module":"share-contest-share-contest-module","payablebalace-popover-payablebalace-popover-module":"payablebalace-popover-payablebalace-popover-module","pick-your-team-pick-your-team-module":"pick-your-team-pick-your-team-module","pickem-basketball-pickem-basketball-module":"pickem-basketball-pickem-basketball-module","pickem-football-pickem-football-module":"pickem-football-pickem-football-module","sharepickemcode-sharepickemcode-module":"sharepickemcode-sharepickemcode-module","basketball-basketball-module":"basketball-basketball-module","cricket-cricket-module":"cricket-cricket-module","football-football-module":"football-football-module","daily-check-in-bonus-daily-check-in-bonus-module":"daily-check-in-bonus-daily-check-in-bonus-module","filter-matches-filter-matches-module":"filter-matches-filter-matches-module","join-contest-join-contest-module":"join-contest-join-contest-module","kabaddi-kabaddi-module":"kabaddi-kabaddi-module","default~leaderboard-leaderboard-module~leaderboard2-leaderboard2-module":"default~leaderboard-leaderboard-module~leaderboard2-leaderboard2-module","leaderboard-leaderboard-module":"leaderboard-leaderboard-module","leaderboard2-leaderboard2-module":"leaderboard2-leaderboard2-module","leaderboard-livepickem-leaderboard-livepickem-module":"leaderboard-livepickem-leaderboard-livepickem-module","leaderboard-pickem-leaderboard-pickem-module":"leaderboard-pickem-leaderboard-pickem-module","switch-team-switch-team-module":"switch-team-switch-team-module","team-comparelive-team-comparelive-module":"team-comparelive-team-comparelive-module","team-comparison-team-comparison-module":"team-comparison-team-comparison-module","bankverify-bankverify-module":"bankverify-bankverify-module","panverify-panverify-module":"panverify-panverify-module","editemail-editemail-module":"editemail-editemail-module","editinfo-editinfo-module":"editinfo-editinfo-module","editphonenumber-editphonenumber-module":"editphonenumber-editphonenumber-module","editusername-popup-editusername-popup-module":"editusername-popup-editusername-popup-module","verify-verify-module":"verify-verify-module","viewpandetails-viewpandetails-module":"viewpandetails-viewpandetails-module","verifyemail-verifyemail-module":"verifyemail-verifyemail-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
